import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CRMActions = require("lib/actions/CRMActions");
var CRMSelectors = require("lib/selectors/CRMSelectors");
var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

var Glyphicon = require("components/utility/icons/Glyphicon");
var LoadingButton = require("components/utility/LoadingButton");
var DropDownOptions = require("components/utility/DropDownOptions");

require("appdev/crm/new_school_org_page.scss");

@connect(
	(state, props) => {
		var dealID = $wr.getURLParameterByName("deal_id");

		if (dealID) {
			var deal = CRMSelectors.deal({ state, id: $wr.getURLParameterByName("deal_id") });
			if (deal) {
				var orgID = (deal.org || {}).id				
			}
		}

		var loading = !!(
			CRMSelectors.isLoadingDeals({ state, key: dealID }) ||
			RosterSelectors.isLoadingSchoolOrgs({ state, key: "create" }) ||
			RosterSelectors.isLoadingDistrictOrgs({ state, key: "create" }) ||
			CRMSelectors.isLoadingContacts({ state, key: orgID })
		)

		return {
			deal, loading
		}

	},
	(dispatch, props) => ({
		populateData: () => {
			var dealID = $wr.getURLParameterByName("deal_id");
			if (dealID) {
				return dispatch(CRMActions.fetchDeal({
					id: dealID, embeds: ["deal.org", "org.child_orgs", "deal.contact"]
				}))
			}
		},

		createSchoolOrg: (schoolOrg, orgID) => {
			function showError(message) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Error!", text: message, 
					icon: "exclamation-sign", type: "error" });
			}

			return dispatch(
				RosterActions.createSchoolOrg({ schoolOrg })
			).then((response) => {
				var schoolOrg = (response.schoolOrgs || [])[0];

				if (!schoolOrg) {
					showError("No school org created!");
					return { success: false };
				}

				if (schoolOrg.errors) {
					showError(schoolOrg.errors.join(", "));
					return { success: false };
				}

				var contactUpdate = {
					custom_fields: {
						"School Org ID": schoolOrg.id
					}
				}

				return dispatch(CRMActions.updateContact(
					{ id: orgID, update: contactUpdate }
				)).then(() => {
					return { success: true, schoolOrg };
				})
			});
		},

		createDistrictOrg: (districtOrg, orgID) => {
			function showError(message) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Error!", text: message, 
					icon: "exclamation-sign", type: "error" });
			}

			return dispatch(
				RosterActions.createDistrictOrg({ districtOrg })
			).then((response) => {
				var districtOrg = (response.districtOrgs || [])[0];

				if (!districtOrg) {
					showError("No district org created!");
					return { success: false };
				}

				if (districtOrg.errors) {
					showError(districtOrg.errors.join(", "));
					return { success: false };
				}

				var contactUpdate = {
					custom_fields: {
						"District Org ID": districtOrg.id
					}
				}

				return dispatch(CRMActions.updateContact(
					{ id: orgID, update: contactUpdate }
				)).then(() => {
					return { success: true, districtOrg };
				})
			});
		},

	})
)
@providePopulateData()
class NewSchoolOrgPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {
			successSchools: {}
		};
	}

	isDistrict() {
		return this.props.deal && this.props.deal.org &&
			this.props.deal.org.custom_fields["Org Level"] === "District";
	}

	schoolInfo(org) {
		if (org.parent_organization_id) {
			var district = "ZDS Contact " + org.parent_organization_id;
		} else {
			var district = "No District";
		}
		return {
			name: org.name,
			district_name: district,
			zip: org.address.postal_code || "00000", 
			canonical_id: org.custom_fields["Canonical School ID"]
		}
	}

	districtInfo(org) {
		return {
			name: org.name,
			zip: org.address.postal_code || "00000", 
			canonical_id: org.custom_fields["Canonical District ID"]
		}
	}

	onSubmitSchool(org, redirectToUpgrade, e) {
		$wr.nope(e);
		
		var schoolOrgInfo = {
			school_info: this.schoolInfo(org),
		}

		if (this.isDistrict()) {
			var districtOrgID = this.props.deal.org.custom_fields["District Org ID"];
			if (districtOrgID) {
				schoolOrgInfo.district_org_id = districtOrgID;				
			}
		}

		this.props.createSchoolOrg(schoolOrgInfo, org.id).then((result) => {
			
			if (result.success) {
				if (this.isDistrict()) {
					this.props.populateData();

					this.setState({
						successSchools: { ...this.state.successSchools, [org.id]: true }
					});

				} else {
					if (redirectToUpgrade) {
						$wr.redirect("/upgrade_tokens?deal_id=" + this.props.deal.id);

					} else {
						this.setState({ created: true });
					}					
				}
			}
		})
	}

	onSubmitDistrict(org, redirectToUpgrade, e) {
		$wr.nope(e);
		
		var districtOrgInfo = this.districtInfo(org);		

		var org = this.props.deal.org;

		districtOrgInfo.school_org_ids = [];
		org.child_orgs.forEach((school) => {
			if (school.custom_fields["School Org ID"]) {
				districtOrgInfo.school_org_ids.push(
					school.custom_fields["School Org ID"]
				);
			}
		})
		
		this.props.createDistrictOrg(districtOrgInfo, org.id).then((result) => {
			if (result.success) {
				if (redirectToUpgrade) {
					$wr.redirect("/upgrade_tokens?deal_id=" + this.props.deal.id);

				} else {
					this.setState({ created: true });
				}
			}
		})

	}

	renderDistrictInfo(org) {
		var districtInfoLines = _.map(this.districtInfo(org), (val, key) => {
			return (
				<li key={ key}>
					<strong>{ key }</strong>: { val }
				</li>
			)
		})

		return (
			<div>
				<p><strong>District Info:</strong></p>
				<ul>
					{ districtInfoLines }
				</ul>
			</div>
		)

	}

	renderSchoolInfo(org) {
		var schoolInfoLines = _.map(this.schoolInfo(org), (val, key) => {
			return (
				<li key={ key}>
					<strong>{ key }</strong>: { val }
				</li>
			)
		})
		if (org.custom_fields["School Org ID"]) {
			var schoolOrgWarning = (
				<p className="redBold">
					This school already has a school org! ID: { org.custom_fields["School Org ID"] }
				</p>
			);
		}

		return (
			<div>
				<p><strong>School Info:</strong></p>
				<ul>
					{ schoolInfoLines }
				</ul>
				{ schoolOrgWarning }
			</div>
		)
	}

	render() {
		if (this.state.created) {
			var noun = this.isDistrict() ? "District" : "School";
			return (
				<div className="newSchoolOrgPage container">
					<header className="pageHeader">
						<h1>Success! New { noun } Org</h1>
					</header>
				</div>
			);
		}
		if (this.props.deal) {
			var dealName = this.props.deal.name;
			var dealLinkBase = "https://app.futuresimple.com/sales/deals/";
			var dealLink = (
				<a href={ dealLinkBase + this.props.deal.id } target="_blank">
					<Glyphicon icon="link" />
				</a>
			);

			var org = this.props.deal.org;
			if (!org) {
				var mainContent = (
					<p className="redBold">
						No org data present. Go and check deal set up, it was done wrong!
					</p>
				);

			} else if (this.isDistrict()) {
				var schoolSections = org.child_orgs.map((childOrg) => {
					if (this.state.successSchools[childOrg.id]) {
						var buttonSection = (
							<p className="greenBold">
								Added school org and to district!
							</p>
						);

					} else if (!childOrg.custom_fields["School Org ID"]) {
						var buttonSection = (
							<LoadingButton className="btn buttonSuccess" text="Submit"
								onClick={ () => this.onSubmitSchool(childOrg) }
								loading={ this.props.loading } />
						);
					}
					return (
						<div className="schoolSection" key={ childOrg.id }>
							{ this.renderSchoolInfo(childOrg) }
							{ buttonSection }
						</div>
					);
				});

				if (org.custom_fields["District Org ID"]) {
					var districtButtonSection = (
						<p className="redBold">
							This district already has a district org! ID: { org.custom_fields["District Org ID"] }
						</p>
					);
				} else {
					var districtButtonSection = (
						<div>
							<LoadingButton className="btn buttonSuccess" text="Submit"
								onClick={ () => this.onSubmitDistrict(org, false) }
								loading={ this.props.loading } />{" "}

							<LoadingButton className="btn btn-default" text="Submit -> Upgrade Tokens"
								onClick={ () => this.onSubmitDistrict(org, true) }
								loading={ this.props.loading } />
						</div>
					);
				}


				var mainContent = (
					<div>
						{ this.renderDistrictInfo(org) }
						{ districtButtonSection }
						<hr />
						<div>
							{ schoolSections }
						</div>
					</div>
				);

			} else {

				if (!org.custom_fields["School Org ID"]) {
					var schoolButtonSection = (
						<div>
							<LoadingButton className="btn buttonSuccess" text="Submit"
								onClick={ () => this.onSubmitSchool(org, false) }
								loading={ this.props.loading } />{" "}

							<LoadingButton className="btn btn-default" text="Submit -> Upgrade Tokens"
								onClick={ () => this.onSubmitSchool(org, true) }
								loading={ this.props.loading } />
						</div>
					)
				}

				var mainContent = (
					<div>
						{ this.renderSchoolInfo(org) }
						{ schoolButtonSection }
					</div>
				);

			}
		}
		return (
			<div className="newSchoolOrgPage container">
				<div className="headerSection">
					<header className="pageHeader">
						<h1>New School/District Org</h1>
					</header>
				</div>

				<p>
					<strong>Deal</strong>: { dealName } { dealLink }
				</p>

				<div>
					{ mainContent }
				</div>

			</div>
		);
	}

};

NewSchoolOrgPage.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from @connect
	deal: PropTypes.object,
	loading: PropTypes.bool,

	// Handlers from @connect
	populateData: PropTypes.func.isRequired,
	createSchoolOrg: PropTypes.func.isRequired,
	createDistrictOrg: PropTypes.func.isRequired
});

module.exports = NewSchoolOrgPage;



// WEBPACK FOOTER //
// ./modules/components/appdev/crm/NewSchoolOrgPage.js